import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { CONTRACT_ADDRESSES } from '../contracts/addresses';
import DividendContractABI from '../contracts/abis/DividendContract.json';
import CryptoFlipABI from '../contracts/abis/CryptoFlip.json';
import BLBTokenABI from '../contracts/abis/BLBToken.json';

export const useContract = (walletData) => {
  const [contracts, setContracts] = useState({
    dividendContract: null,
    cryptoFlipContract: null,
    blbTokenContract: null
  });

  useEffect(() => {
    if (walletData.provider && walletData.account) {
      initializeContracts();
    } else {
      setContracts({
        dividendContract: null,
        cryptoFlipContract: null,
        blbTokenContract: null
      });
    }
  }, [walletData.provider, walletData.account]);

  const initializeContracts = async () => {
    try {
      const signer = walletData.provider.getSigner();
      let contracts = {
        dividendContract: null,
        cryptoFlipContract: null,
        blbTokenContract: null
      };

      // Only initialize contracts if addresses are provided
      if (CONTRACT_ADDRESSES.DIVIDEND_CONTRACT) {
        contracts.dividendContract = new ethers.Contract(
          CONTRACT_ADDRESSES.DIVIDEND_CONTRACT,
          DividendContractABI,
          signer
        );
      }

      if (CONTRACT_ADDRESSES.CRYPTOFLIP_CONTRACT) {
        contracts.cryptoFlipContract = new ethers.Contract(
          CONTRACT_ADDRESSES.CRYPTOFLIP_CONTRACT,
          CryptoFlipABI,
          signer
        );
      }

      if (CONTRACT_ADDRESSES.BLB_TOKEN) {
        contracts.blbTokenContract = new ethers.Contract(
          CONTRACT_ADDRESSES.BLB_TOKEN,
          BLBTokenABI,
          signer
        );
      }

      setContracts(contracts);

    } catch (error) {
      console.error('Error initializing contracts:', error);
      setContracts({
        dividendContract: null,
        cryptoFlipContract: null,
        blbTokenContract: null
      });
    }
  };

  return contracts;
};